import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';

// NOTE: This function only updates the state if the values change, NOT the pointer of the object!
export function useCachedObjectValue<T>(value: T): T {
	const [cachedValue, setCachedValue] = useState<T>(value);
	useEffect(() => {
		if (!value) {
			// eslint-disable-next-line
			if (value !== cachedValue) setCachedValue(value);
			return;
		}

		const compareValue = _.isArray(value) ? value.sort() : _.isFunction(value) ? (value?.toString() as T) : value;
		if (_.isEqual(compareValue, _.isFunction(cachedValue) ? (cachedValue?.toString() as T) : cachedValue)) {
			return;
		}
		setCachedValue(_.isFunction(value) ? value : compareValue);
	}, [value, cachedValue]);
	return useMemo(() => cachedValue, [cachedValue]);
}
